<template>
  <div class="plv-ia-checkin-detail">
    <div class="plv-ia-checkin-detail__body">
      <div ref="list" class="plv-ia-checkin-detail__scroll">
        <div class="plv-ia-checkin-detail-brief">
          <div class="plv-ia-checkin-detail-brief__left plv-ia-clearfix">
            <div class="plv-ia-checkin-detail-brief__item pws-vclass-checkin-detail-brief__item">{{ t('plvIA.checkIn.onlineNum') }}<span>{{ mainData.onlineNum }}</span></div>
            <div class="plv-ia-checkin-detail-brief__item pws-vclass-checkin-detail-brief__item">{{ t('plvIA.checkIn.checkInNum') }}<span>{{ mainData.checkInNum }}</span></div>
            <div class="plv-ia-checkin-detail-brief__item pws-vclass-checkin-detail-brief__item">{{ t('plvIA.checkIn.rate') }}<span>{{ checkInPercent }}</span></div>
          </div>
          <div class="plv-ia-checkin-detail-brief__right">
            <span
              v-if="right.sendResult"
              class="plv-ia-btn-text pws-vclass-btn-text"
              @click="handleSendResult"
            >{{ t('plvIA.checkIn.sendResult') }}</span>
          </div>
        </div>

        <div class="plv-ia-checkin-detail-list">
          <div class="plv-ia-checkin-detail-list__header">{{ t('plvIA.checkIn.attendedList') }}</div>
          <div
            class="plv-ia-checkin-detail-list__body"
            :class="{
              'plv-ia-checkin-detail-list__body--nobottom': hideBottomLine(attendedList)
            }"
          >
            <template v-if="hasContent(attendedList)">
              <div v-for="(list, listIndex) in attendedList" :key="listIndex" class="plv-ia-checkin-detail-list__row">
                <span v-for="(item) in list" :key="item.id" :data-id="item.id">{{ item.nickname }}</span>
              </div>
            </template>
            <div v-else class="plv-ia-checkin-detail-list__row">
              <p>{{ t('plvIA.checkIn.noRecords') }}</p>
            </div>
          </div>
        </div>

        <div v-if="hasContent(absentList)" class="plv-ia-checkin-detail-list">
          <div class="plv-ia-checkin-detail-list__header">{{ t('plvIA.checkIn.absentList') }}</div>
          <div
            class="plv-ia-checkin-detail-list__body"
            :class="{
              'plv-ia-checkin-detail-list__body--nobottom': hideBottomLine(absentList)
            }"
          >
            <div v-for="(list, listIndex) in absentList" :key="listIndex" class="plv-ia-checkin-detail-list__row">
              <span v-for="(item) in list" :key="item.id" :data-id="item.id">{{ item.nickname }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="plv-ia-checkin-detail__footer">
      <span
        v-if="right.download && mainData.onlineNum > 0"
        class="plv-ia-btn-new plv-ia-checkin-detail-btn--wide pws-vclass-checkin-detail-btn--wide"
        @click="download"
      >{{ t('plvIA.checkIn.clickToDownload') }}</span>
      <button
        class="plv-ia-btn-new plv-ia-btn-blue pws-vclass-btn-blue"
        :class="{ 'plv-ia-checkin-detail-btn--wide': isFromHistoryList }"
        @click="close"
      >
        {{ isFromHistoryList ? t('plvIA.checkIn.backToHistory') : t('plvIA.checkIn.close') }}
      </button>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
import { calculatePercent } from './helper';

function formatList(data) {
  const list = [];
  data.forEach((item, index) => {
    const listIndex = Math.floor(index / 3);
    if (!list[listIndex]) {
      list[listIndex] = [item];
    } else {
      list[listIndex].push(item);
    }
  });
  return list;
}

export default {
  mixins: [Locale],
  props: {
    mainData: {
      type: Object,
      default: null,
    },
    curCheckInId: {
      type: String,
      default: '',
    },
    right: {
      type: Object,
      default: null,
    },
  },

  computed: {
    checkInPercent() {
      return calculatePercent(this.mainData.checkInNum, this.mainData.onlineNum);
    },

    // 已签到名单
    attendedList() {
      const list = this.mainData.list;
      if (!list || list.length <= 0) return [];
      return formatList(list.filter(item => item.isCheckedIn));
    },

    // 未签到名单
    absentList() {
      const list = this.mainData.list;
      if (!list || list.length <= 0) return [];
      return formatList(list.filter(item => !item.isCheckedIn));
    },

    elList() {
      return this.$refs.list;
    },

    isFromHistoryList() {
      return this.mainData.checkInId && this.curCheckInId !== this.mainData.checkInId;
    }
  },

  mounted() {
    this.elList.addEventListener('scroll', this.handleScroll);
  },

  beforeDestory() {
    this.elList.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    hideBottomLine(list) {
      return !this.hasContent(list) || list.length <= 1;
    },

    hasContent(arr) {
      return arr && arr.length > 0;
    },

    close() {
      this.$emit('close');
    },

    handleSendResult() {
      this.$emit('send-result', this.mainData.checkInId);
    },

    // 滑动到底部加载更多
    handleScroll() {
      if (this.mainData.isEnd) return;
      const el = this.elList;

      const scrollTop = el.scrollTop;
      const clientHeight = el.clientHeight;
      const scrollHeight = el.scrollHeight;

      if (scrollTop + clientHeight >= scrollHeight) {
        this.$emit('get-more', {
          page: this.mainData.page + 1,
          checkInId: this.mainData.checkInId,
        });
      }
    },

    download() {
      this.$emit('download-detail');
    }
  }
};
</script>

<style lang="scss">
$blue: #2196F3;
$briefWid: 7em;

.plv-ia-checkin-detail {
  width: 100%;
  height: 100%;
  position: relative;
}
.plv-ia-checkin-detail__body {
  padding-bottom: 70px;
  height: 100%;
  box-sizing: border-box;
}
.plv-ia-checkin-detail__scroll {
  height: 100%;
  overflow: auto;
  padding: 0 16px;
}
.plv-ia-checkin-detail-brief {
  position: relative;
  line-height: 48px;
  height: 48px;
}
.plv-ia-checkin-detail-brief__left {
  width: 100%;
  box-sizing: border-box;
  padding-right: $briefWid;
}
.plv-ia-checkin-detail-brief__right {
  width: $briefWid;
  position: absolute;
  right: 0;
  top: 0;

  .plv-ia-btn-text {
    text-align: right;
    white-space: nowrap;
  }
}
.plv-ia-checkin-detail-brief__item {
  width: 33.33%;
  float: left;
  color: #333;
  font-size: 14px;
  height: 48px;

  span {
    color: $blue;
    font-size: 16px;
    margin-left: 5px;
  }
}
.plv-ia-checkin-detail-list {
  margin-bottom: 24px;
  line-height: 48px;
  color: #333;
}
.plv-ia-checkin-detail-list__header {
  background: #EDF1F7;
  border-bottom: 1px solid #CFD8DC;
  text-align: center;
}
.plv-ia-checkin-detail-list__body {
  border-bottom: 1px solid #CFD8DC;
}
.plv-ia-checkin-detail-list__body--nobottom {
  border-bottom: 0;
}

.plv-ia-checkin-detail-list__row {
  font-size: 0;
  height: 48px;
  &:nth-child(odd) {
    background: #fff;
  }
  &:nth-child(even) {
    background: #F8F8FB;
  }

  >* {
    font-size: 14px;
    text-align: center;
  }

  span {
    display: inline-block;
    width: 33.33%;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 8px;
  }

  p {
    color: #757575;
  }
}
.plv-ia-checkin-detail__footer {
  position: absolute;
  width: 100%;
  height: 70px;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  padding-top: 24px;
  font-size: 0;

  .plv-ia-btn-new + .plv-ia-btn-new {
    margin-left: 8px;
  }
}
.plv-ia-checkin-detail-btn--wide {
  width: 120px;
}
</style>
